import React from 'react';
import { Database, ShieldCheck } from 'lucide-react';

export const CutoverStatusBanner = ({ compact = false }) => (
  <div
    className={`flex items-center gap-3 border border-amber-300 bg-amber-50 text-amber-950 ${compact ? 'px-3 py-1.5' : 'px-4 py-3'} rounded-lg`}
    data-testid={compact ? 'cutover-legacy-status-badge-compact' : 'cutover-legacy-status-banner'}
  >
    <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-amber-100">
      {compact ? <Database className="h-4 w-4" /> : <ShieldCheck className="h-4 w-4" />}
    </span>
    <div className="min-w-0">
      <p className="text-sm font-semibold">Fonte attuale: API legacy</p>
      {!compact && <p className="text-xs text-amber-800">Nessun cutover attivo · le operazioni di questo modulo non modificano i dati live</p>}
    </div>
  </div>
);